import ComponentLayout from 'common/ComponentLayout/Component';
import AddExpenditure from './AddExpenditure/AddExpenditure';

const NewExpenditure = () => (
  <ComponentLayout title="Add Expenditure" component={AddExpenditure} />
);

export default NewExpenditure;
